var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _path2, _path3, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path4, _path5, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 124,
    viewBox: "0 0 70 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM8 4H9V1H8H7V4H8Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 22,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 42,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 52,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 62,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 72,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 82,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 92,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 102,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 112,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 123.707C7.68342 124.098 8.31658 124.098 8.70711 123.707L15.0711 117.343C15.4616 116.953 15.4616 116.319 15.0711 115.929C14.6805 115.538 14.0474 115.538 13.6569 115.929L8 121.586L2.34315 115.929C1.95262 115.538 1.31946 115.538 0.928932 115.929C0.538408 116.319 0.538408 116.953 0.928932 117.343L7.29289 123.707ZM8 120H7V123H8H9V120H8Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7071 0.292893C35.3166 -0.0976311 34.6834 -0.0976311 34.2929 0.292893L27.9289 6.65685C27.5384 7.04738 27.5384 7.68054 27.9289 8.07107C28.3195 8.46159 28.9526 8.46159 29.3431 8.07107L35 2.41421L40.6569 8.07107C41.0474 8.46159 41.6805 8.46159 42.0711 8.07107C42.4616 7.68054 42.4616 7.04738 42.0711 6.65685L35.7071 0.292893ZM35 4H36V1H35H34V4H35Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 12,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 22,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 32,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 42,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 52,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 62,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 72,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 82,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 92,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 102,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 112,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2929 123.707C34.6834 124.098 35.3166 124.098 35.7071 123.707L42.0711 117.343C42.4616 116.953 42.4616 116.319 42.0711 115.929C41.6805 115.538 41.0474 115.538 40.6569 115.929L35 121.586L29.3431 115.929C28.9526 115.538 28.3195 115.538 27.9289 115.929C27.5384 116.319 27.5384 116.953 27.9289 117.343L34.2929 123.707ZM35 120H34V123H35H36V120H35Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7071 0.292893C62.3166 -0.0976311 61.6834 -0.0976311 61.2929 0.292893L54.9289 6.65685C54.5384 7.04738 54.5384 7.68054 54.9289 8.07107C55.3195 8.46159 55.9526 8.46159 56.3431 8.07107L62 2.41421L67.6569 8.07107C68.0474 8.46159 68.6805 8.46159 69.0711 8.07107C69.4616 7.68054 69.4616 7.04738 69.0711 6.65685L62.7071 0.292893ZM62 4H63V1H62H61V4H62Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 12,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 22,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 32,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 52,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 72,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 82,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 92,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 102,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 112,
    r: 2,
    fill: "#9C9C9C",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2929 123.707C61.6834 124.098 62.3166 124.098 62.7071 123.707L69.0711 117.343C69.4616 116.953 69.4616 116.319 69.0711 115.929C68.6805 115.538 68.0474 115.538 67.6569 115.929L62 121.586L56.3431 115.929C55.9526 115.538 55.3195 115.538 54.9289 115.929C54.5384 116.319 54.5384 116.953 54.9289 117.343L61.2929 123.707ZM62 120H61V123H62H63V120H62Z",
    fill: "#9C9C9C",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyns);
export default __webpack_public_path__ + "static/media/syns.c99219938a0a8d448ffed5b4a41b0114.svg";
export { ForwardRef as ReactComponent };